import React, { useState } from 'react';
import { UploadIcon } from 'tdesign-icons-react';
import { Button } from 'tdesign-react';

import { labelDom, LabelDomProps } from '@/components/Label';
import { ImageRatio } from '@/const/richMedia';
import { PageIds } from '@/const/tip';
import { RichMediaValue } from '@/interface/media';
import UploadPic from '@/material/form-upload/image';
import { useTypedSelector } from '@/store';

import styles from './index.module.less';

export interface ImageInfo {
  url: string;
  width?: number;
  height?: number;
}

interface IProps {
  onChange: (key: ImageInfo) => void;
  value: ImageInfo;
  fieldname: string;
  labelSetting: {
    tipIcon: boolean;
    tipText: string;
  };
  disabled?: boolean;
}

const CustomAigcImage: React.FC<IProps> = ({ value, onChange, labelSetting, disabled = false, ...props }) => {
  const [showUploadPic, setShowUploadPic] = useState<boolean>(false);
  const tipList = useTypedSelector(store => store.tip);

  const addImage = () => {
    setShowUploadPic(true);
  };

  const handleOnChange = (data?: RichMediaValue, imageInfo?: any) => {
    const baseImageUrl = data?.url?.url || '';
    const baseImageInfo: ImageInfo = {
      url: baseImageUrl,
      width: imageInfo?.width,
      height: imageInfo?.height,
    };
    onChange(baseImageInfo);

    if (!baseImageUrl) {
      setShowUploadPic(false);
    }
  };

  const labelProps: LabelDomProps = {
    field: { labelSetting, props: props.fieldname, ...props },
    initFormData: '',
    pageId: PageIds.AIGC_INFO,
    tipList,
  };

  return (
    <div className={styles.container}>
      {labelDom(labelProps)}
      <Button
        theme='default'
        onClick={addImage}
        className={styles.button}
        disabled={disabled}
      >
        <div className={styles.text}>
          <UploadIcon />上传图片
        </div>
      </Button>
      <div className={styles.uploadPicContainer}>
        {showUploadPic && (
          <UploadPic
            value={{ url: value }}
            onChange={handleOnChange}
            width={150}
            height={150}
            isShowAigc={false}
            btnText="上传图片"
            wrapStyle={{ border: 'none' }}
            limit={{ ratio: ImageRatio.unlimited }}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};

export default CustomAigcImage;
